import '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import spartaWidgetLoaderUtility from '@sparta.global.utilities/sparta-widget-loader-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<div id=\"spaGlobalSearchWidgetContainer\"></div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row static-search show-for-medium-up\">\r\n  <div class=\"column small-12\">\r\n    <form class=\"form\"\r\n      action=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"searchUrl") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":7,"column":14},"end":{"line":7,"column":111}}})) != null ? stack1 : "")
    + "\"\r\n      method=\"get\">\r\n      <label for=\"nav-static-search\" class=\"ada-hidden\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"label") : stack1), depth0)) != null ? stack1 : "")
    + "</label>\r\n      <input id=\"nav-static-search\" class=\"form--input\" type=\"text\" name=\"state\" rel=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "\"\r\n        maxlength=\"99\" placeholder=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"placeholder") : stack1), depth0)) != null ? stack1 : "")
    + "\" autocomplete=\"off\" aria-autocomplete=\"list\">\r\n      <button type=\"submit\" alt=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "\" title=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0))
    + "\"\r\n        value=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"submit") : stack1), depth0))
    + "\" name=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"tracking") : stack1), depth0))
    + "\"\r\n        class=\"form--btn form--search-icon spa-btn spa-btn--small track-me\">\r\n      </button>\r\n    </form>\r\n  </div>\r\n</div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"searchUrl") : stack1), depth0));
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"searchStub") : depth0)) != null ? lookupProperty(stack1,"searchUrlFallback") : stack1), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"isSearchWidget") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":19,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-gt.modules/search-stub-module",
  "version": "1.0.8",
  "id": "searchStubModule",
  "containerID": "globalGtSearchStubModule",
  "moduleName": "global-gt-search-stub-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "search-stub-module",
  "data": {
    "init": "SearchStubModule",
    "options": {}
  },
  "moduleParams": [{
    "name": "inputExperience",
    "type": "string",
    "values": ["header", "stage"],
    "default": "header",
    "description": "This parameter controls the UI experience of Search Input Box along with Search Icon. If widget is part of page section, then pass value as 'stage'. Help & Support / Search Results pages should pass it as 'stage' as per current ask."
  }, {
    "name": "resultsContainerId",
    "type": "string",
    "values": [],
    "default": null,
    "description": "This is an optional parameter. It is used to pass the ID of the target container in which the search results section needs to be rendered on page. Set only when resultsExperience parameter value is 'inline'. Search Results pages should pass the ID as results are shown in page section stage area as per current ask."
  }, {
    "name": "resultsExperience",
    "type": "string",
    "values": ["flyout", "inline"],
    "default": "flyout",
    "description": "This parameter controls the display of Search Results. There are two use cases where results are shown as part of flyout popup same as header or inline to page section. If search results are shown in page section, then pass value as 'inline'. Only Search Results page should pass it as 'inline' as per current ask."
  }, {
    "name": "rule",
    "type": "string",
    "values": ["small", "medium", "large", "not-small", "not-large", "all"],
    "default": "large",
    "description": "Sets the data-rwd-content-rule that the share-content-utility swaps based on viewport."
  }, {
    "name": "isSearchWidget",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Determines if the sparta widget or static form will be used. *IMPORTANT* The static form has only been designed to work on the homepage header"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-widget-loader-utility": "^6.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.vendors/jquery": "^3.7.1"
  },
  "stores": []
};

/* global sparta */
/**
 * @file        search-stub-module.js
 * @description This module is responsible for rendering the global search experience.
 * @author      Dixit, Rahul
 * @copyright   © 2022 Bank of America Corporation. All rights reserved.
 */
class searchStubModuleJS extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Creates an instance of searchStubModuleJS.
   * @memberof searchStubModuleJS
   */

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    this.loader_Version = '6.0.5';
    this.widget_Version = '2.0.0';
    this.widgetSetup = {};
    if (this.params.isSearchWidget) {
      this.viewport = spartaMediaQueryUtility.matchedQuery.viewport;
      try {
        this.isAuth = document.domain && document.domain.includes('secure');
        this.searchContainerEl = this.settings.target.querySelector('#spaGlobalSearchWidgetContainer');
        this.widgetReadyEvent = 'WIDGET_READY.widget-global-search-public-widget';
        if (this.params.inputExperience === 'stage') {
          this.loadGlobalSearchWidget(this.searchContainerEl);
        } else {
          this.smallSearchContainerEl = document.querySelector('.small-search .header-search');
          this.smallSearchContainerEl.id = 'smallSearchContainer';
          this.setupContainer();
        }
      } catch (error) {
        // Integrate Sparta Instrumenation Utility
        console.log(error);
      }
    } else {
      // Clone static form and append to the menu dropdown container
      this.formEl = this.settings.target.querySelector('.form');
      this.smallFormEl = this.formEl.cloneNode(true);
      this.smallSearchContainer = document.querySelector('.small-search .header-search');
      if (this.formEl && this.smallSearchContainer) {
        this.smallSearchContainer.appendChild(this.smallFormEl);
      }
    }
  }

  /**
   *
   * Called to load global search widget.
   * @param {*} searchContainer target node for widget
   * @returns {void}
   */
  loadGlobalSearchWidget(searchContainer) {
    if (this.widgetSetup[searchContainer.id]) {
      return;
    }
    this.widgetSetup[searchContainer.id] = true;
    const {
      env
    } = this.spaParams.siteParams;
    const {
      inputExperience,
      resultsExperience,
      resultsContainerId
    } = this.params;
    const isLocal = env === 'local';
    try {
      const widgetBaseURL = '';
      const LOADER_VERSION = this.loader_Version;
      const globalSearchWidget = {
        name: this.isAuth ? 'global-search-widget' : 'global-search-public-widget',
        version: this.widget_Version,
        loaderVersion: LOADER_VERSION,
        container: searchContainer.id,
        path: widgetBaseURL,
        language: sparta.language || 'en',
        spinner: false,
        options: {
          inputExperience,
          resultsContainerId,
          resultsExperience,
          withoutCredentials: isLocal,
          onLoad: this.spartaLoaderLoaded.bind(this)
        }
      };

      // Homepage sites need stage for small and medium
      const homepageSites = ['homepage', 'hp-assets', 'notice-hp-outage'];
      if (this.viewport.indexOf('large') === -1 && homepageSites.indexOf(spaParams.siteName) > -1) {
        globalSearchWidget.options.inputExperience = 'stage';
        globalSearchWidget.options.resultsExperience = 'flyout';
      }
      spartaWidgetLoaderUtility.load(globalSearchWidget);
    } catch (error) {
      // Integrate Sparta Instrumenation Utility
      console.log(error);
    }
  }

  /**
   * Called to setup search container
   * @returns {void}
   */
  setupContainer() {
    this.isAuth ? 'global-search-widget' : 'global-search-public-widget';
    let ruleCheck = this.viewport.indexOf('small') > -1;
    if (this.params.rule === 'large') {
      ruleCheck = ruleCheck || this.viewport.indexOf('medium') > -1;
    }
    if (ruleCheck) {
      try {
        if (spartaWidgetLoaderUtility && spartaWidgetLoaderUtility.getInstance(this.searchContainerEl.id)) {
          spartaWidgetLoaderUtility.destroy(this.searchContainerEl.id);
        }
        this.widgetSetup[this.searchContainerEl.id] = false;
      } catch (error) {
        console.warn("Search stub module :: Couldn't destroy widget", error);
      }
      this.loadGlobalSearchWidget(this.smallSearchContainerEl);
    } else {
      try {
        if (spartaWidgetLoaderUtility && spartaWidgetLoaderUtility.getInstance(this.smallSearchContainerEl.id)) {
          spartaWidgetLoaderUtility.destroy(this.smallSearchContainerEl.id);
        }
        this.widgetSetup[this.smallSearchContainerEl.id] = false;
      } catch (error) {
        console.warn("Search stub module :: Couldn't destroy widget", error);
      }
      this.loadGlobalSearchWidget(this.searchContainerEl);
    }
  }

  /**
   * Sparta loader handler
   * @param {*} widget search widget
   * @returns {void}
   */
  spartaLoaderLoaded(widget) {
    this.bindEvents();
  }

  /**
   * Called to setup event listeners
   * @returns {void}
   */
  bindEvents() {
    if (this.params.inputExperience === 'stage' || this.eventsBound) return;
    this.eventsBound = true;
    this.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, data => {
      if (data && data.data && data.data.viewport) {
        this.viewport = data.data.viewport;
        this.setupContainer();
      }
    });
  }
}
registerModuleClass({
  moduleClass: searchStubModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { searchStubModuleJS as default, moduleConfig };
